<template>
  <v-container>
    <v-row :justify="$vuetify.breakpoint.mdAndDown ? 'center' : 'start'" align="center">
      <v-col cols="12">
        <title-text>Investments.</title-text>
      </v-col>
      <v-col cols="12">
        <div class="d-flex overflow-x-auto">
          <v-alert
            @click="selectIndex(i)"
            tile
            dark
            :outlined="selectedIndex != i"
            :color="selectedIndex == i ? 'secondary' : 'primary'"
            class="d-flex mr-2 cursor-pointer"
            :class="{
              'py-2 px-3 text-body-1': $vuetify.breakpoint.smAndDown,
              'py-4 px-8': !$vuetify.breakpoint.mdAndDown,
            }"
            v-for="(option, i) in options"
            :key="i"
          >{{ option }}</v-alert>
        </div>
      </v-col>
    </v-row>
    <Offers v-if="selectedIndex == 0" />
    <Investments @handleNoInvestments="selectIndex(0)" v-if="selectedIndex == 1" />
    <Pending @handlePending="selectIndex(0)" v-if="selectedIndex == 2" />
  </v-container>
</template>

<script>
import TitleText from "@/components/dashboard/DbTitleText.vue";
import Pending from "./Pending";
import Investments from "./Investments";
import Offers from "./Offers";

export default {
  components: {
    TitleText,
    Pending,
    Investments,
    Offers,
  },
  data() {
    return {
      selectedIndex: 0,
      aboutDialog: null,
      group: null,
      options: ["Offers", "Investments", "Pending"],
    };
  },
  methods: {
    selectIndex(value) {
      this.selectedIndex = value;
    },
  },
};
</script>
